import { IWalletEvent, IWalletEventMetadata, IWalletEventTicketCode } from 'meta/pages/v4/wallet'
import { useAppSelector } from 'store'
import { WalletSelectors } from 'store/pages/wallet'

export const useWalletPastEvents = (): Record<number, Array<IWalletEvent>> =>
  useAppSelector(WalletSelectors.getWalletPastEvents())

export const useWalletUpcomingEvents = (): Record<number, Array<IWalletEvent>> =>
  useAppSelector(WalletSelectors.getWalletUpcomingEvents())

export const useWalletPastGoodsServices = (): Record<number, Array<IWalletEvent>> =>
  useAppSelector(WalletSelectors.getWalletPastGoodsServices())

export const useWalletUpcomingGoodsServices = (): Record<number, Array<IWalletEvent>> =>
  useAppSelector(WalletSelectors.getWalletUpcomingGoodsServices())

export const useWalletPastEventsMetadata = (): IWalletEventMetadata =>
  useAppSelector(WalletSelectors.getWalletPastEventsMetadata())

export const useWalletUpcomingEventsMetadata = (): IWalletEventMetadata =>
  useAppSelector(WalletSelectors.getWalletUpcomingEventsMetadata())

export const useWalletPastGoodsServicesMetadata = (): IWalletEventMetadata =>
  useAppSelector(WalletSelectors.getWalletPastGoodsServicesMetadata())

export const useWalletUpcomingGoodsServicesMetadata = (): IWalletEventMetadata =>
  useAppSelector(WalletSelectors.getWalletUpcomingGoodsServicesMetadata())

export const useWalletEventTicketCodes = ({
  eventIdOrCodeUrl,
}: {
  eventIdOrCodeUrl: string
}): Array<IWalletEventTicketCode> | undefined =>
  useAppSelector(WalletSelectors.getWalletEventTicketCodes({ eventIdOrCodeUrl }))

export const useWalletEventTicketCodesMetadata = ({
  eventIdOrCodeUrl,
}: {
  eventIdOrCodeUrl: string
}): IWalletEventMetadata | undefined =>
  useAppSelector(WalletSelectors.getWalletEventTicketCodesMetadata({ eventIdOrCodeUrl }))
